import type { Middleware } from "@reduxjs/toolkit";

import { isAction } from "@reduxjs/toolkit";

const redirectMiddleware: Middleware = () => (next) => (action) => {
  if (!isAction(action) || !action.type.endsWith("_SUCCESS")) {
    return next(action);
  }

  const redirectTo = (action as { payload?: { redirectTo?: string } })?.payload
    ?.redirectTo;
  if (!redirectTo) {
    return next(action);
  }

  window.location.replace(redirectTo);
  return undefined;
};

export default redirectMiddleware;
